import axios from 'axios';
import * as types from '../constants/ActionTypes';

const chatBotSessionURL = '/smarthelp/node-chat/sync-session';

function requestChatBotSessionChecker() {
  return { type: types.REQUEST_CHAT_BOT_SESSION };
}

function receivedChatBotSessionResult(responseData) {
  return { type: types.RECEIVE_CHAT_BOT_SESSION_RESULT, payload: responseData };
}

function catchChatBotSessionError() {
  return { type: types.CATCH_CHAT_BOT_SESSION_ERROR };
}

function fetchChatBotSessionChecker(options) {
  return (dispatch) => {
    dispatch(requestChatBotSessionChecker());
    return axios.get(chatBotSessionURL)
      .then((response) => {
        dispatch(receivedChatBotSessionResult());
        if (options && typeof options.callBack === 'function') {
          options.callBack(response.data);
        }
      })
      .catch(() => {
        dispatch(catchChatBotSessionError());
        if (options && typeof options.callBack === 'function') {
          options.callBack();
        }
      });
  };
}

function chatBotClickedAction() {
  return (dispatch) => {
    dispatch({ type: types.CHATBOT_CLICKED });
  };
}

function chatBotClickedFalseAction() {
  return (dispatch) => {
    dispatch({ type: types.CHATBOT_CLICKED_FALSE });
  };
}

module.exports = {
  fetchChatBotSessionChecker,
  chatBotClickedAction,
  chatBotClickedFalseAction,
};
